import { Component } from "react";
import axios from "axios";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter";
import { funcNavigate } from "../../../../settings/utils/functions";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { header } from "../../components/header";
import { footer } from "../../components/footer";
import { toastAlerts } from "../../../../settings/utils/toastify";
import { BASE_URL, TIMEOUT } from "../../../../settings/utils/config";
import SearchableSelect from "../../../components/searchableSelect/SearchableSelect";

const JOB_CHOICES = [
    { value: "other", label: "سایر" },
    { value: "student", label: "دانشجو" },
    { value: "faculty", label: "هیئت علمی" },
];

const MOASSESE_CHOICES = [
    { value: "other", label: "سایر" },
    { value: "tehran", label: "دانشگاه علوم پزشکی تهران" },
    { value: "beheshti", label: "دانشگاه علوم پزشکی شهید بهشتی" },
    { value: "iran", label: "دانشگاه علوم پزشکی ایران" },
    { value: "isfahan", label: "دانشگاه علوم پزشکی اصفهان" },
    { value: "shiraz", label: "دانشگاه علوم پزشکی شیراز" },
    { value: "tabriz", label: "دانشگاه علوم پزشکی تبریز" },
    { value: "mashhad", label: "دانشگاه علوم پزشکی مشهد" },
    { value: "ahvaz", label: "دانشگاه علوم پزشکی جندی‌شاپور اهواز" },
    { value: "kerman", label: "دانشگاه علوم پزشکی کرمان" },
    { value: "mazandaran", label: "دانشگاه علوم پزشکی مازندران" },
    { value: "baqiyatallah", label: "دانشگاه علوم پزشکی بقیةالله" },
    { value: "yazd", label: "دانشگاه علوم پزشکی شهید صدوقی یزد" },
    { value: "kermanshah", label: "دانشگاه علوم پزشکی کرمانشاه" },
    { value: "urmia", label: "دانشگاه علوم پزشکی ارومیه" },
    { value: "zahedan", label: "دانشگاه علوم پزشکی زاهدان" },
    { value: "kashan", label: "دانشگاه علوم پزشکی کاشان" },
    { value: "babol", label: "دانشگاه علوم پزشکی بابل" },
    { value: "hamedan", label: "دانشگاه علوم پزشکی همدان" },
    { value: "qazvin", label: "دانشگاه علوم پزشکی قزوین" },
    { value: "golestan", label: "دانشگاه علوم پزشکی گلستان" },
    { value: "arak", label: "دانشگاه علوم پزشکی اراک" },
    { value: "gilan", label: "دانشگاه علوم پزشکی گیلان" },
    { value: "zanjan", label: "دانشگاه علوم پزشکی زنجان" },
    { value: "rafsanjan", label: "دانشگاه علوم پزشکی رفسنجان" },
    { value: "shahed", label: "دانشگاه علوم پزشکی شاهد" },
    { value: "lorestan", label: "دانشگاه علوم پزشکی لرستان" },
    { value: "hormozgan", label: "دانشگاه علوم پزشکی هرمزگان" },
    { value: "semnan", label: "دانشگاه علوم پزشکی سمنان" },
    { value: "birjand", label: "دانشگاه علوم پزشکی بیرجند" },
    { value: "ardabil", label: "دانشگاه علوم پزشکی اردبیل" },
    { value: "shahrekord", label: "دانشگاه علوم پزشکی شهرکرد" },
    { value: "north-khorasan", label: "دانشگاه علوم پزشکی خراسان شمالی" },
    { value: "ilam", label: "دانشگاه علوم پزشکی ایلام" },
    { value: "bushehr", label: "دانشگاه علوم پزشکی بوشهر" },
    { value: "kurdistan", label: "دانشگاه علوم پزشکی کردستان" },
    { value: "qom", label: "دانشگاه علوم پزشکی قم" },
    { value: "yasuj", label: "دانشگاه علوم پزشکی یاسوج" },
    { value: "gonabad", label: "دانشگاه علوم پزشکی گناباد" },
    { value: "jahrom", label: "دانشگاه علوم پزشکی جهرم" },
    { value: "shahroud", label: "دانشگاه علوم پزشکی شاهرود" },
    { value: "army", label: "دانشگاه علوم پزشکی ارتش" },
    { value: "sabzevar", label: "دانشگاه علوم پزشکی سبزوار" },
    { value: "zabol", label: "دانشگاه علوم پزشکی زابل" },
    { value: "fasa", label: "دانشگاه علوم پزشکی فسا" },
    { value: "alborz", label: "دانشگاه علوم پزشکی البرز" },
    { value: "torbat", label: "دانشگاه علوم پزشکی تربت حیدریه" },
    { value: "jiroft", label: "دانشگاه علوم پزشکی جیرفت" },
    { value: "dezful", label: "دانشگاه علوم پزشکی دزفول" },
    { value: "ministry-science", label: "وزارت علوم" },
];

class Profile extends Component {
    static contextType = simplyContext;

    state = {
        activeTab: "info",
        loading: true,
        saving: false,
        changingPassword: false,
        checkingAuth: true,

        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        codeMelli: "",
        jobs: "",
        jobsOther: "",
        moassese: "",
        moasseseOther: "",
        errors: {},
        generalError: "",

        currentPassword: "",
        newPassword: "",
        newPassword2: "",
        passwordErrors: {},
        passwordGeneralError: "",
    };

    componentDidMount() {
        window.scrollTo(0, 0);

        const token = sessionStorage.getItem("authorization");
        if (!token) {
            this.context.fPreloader(false);
            this.context.fNavigate("/login");
            return;
        }

        this.context.fPreloader(true);
        this.fetchProfile();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context);
    }

    authHeaders = () => ({
        "Content-Type": "application/json",
        "Authorization": sessionStorage.getItem("authorization") || "",
    });

    scrollToFormTop = () => {
        setTimeout(() => {
            const el = document.getElementById("profile-form-top");
            if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }, 100);
    };

    fetchProfile = () => {
        axios.get(
            BASE_URL + "/api/v1/accounts/profile/",
            {
                timeout: TIMEOUT,
                headers: this.authHeaders(),
            }
        ).then((response) => {
            const data = response.data.data;
            this.setState({
                firstName: data.firstName || "",
                lastName: data.lastName || "",
                phoneNumber: data.phoneNumber || "",
                email: data.email || "",
                codeMelli: data.codeMelli || "",
                jobs: data.jobs || "",
                jobsOther: data.jobsOther || "",
                moassese: data.moassese || "",
                moasseseOther: data.moasseseOther || "",
                loading: false,
                checkingAuth: false,
            });
            this.context.fPreloader(false);
        }).catch((error) => {
            toastAlerts(error.response);
            if (error.response?.status === 401) {
                sessionStorage.removeItem("authorization");
                this.context.fSetLoggedIn(false);
                this.context.fNavigate("/login");
            }
            this.context.fPreloader(false);
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => {
            const next = {
                [name]: value,
                errors: { ...prev.errors, [name]: "" },
                passwordErrors: { ...prev.passwordErrors, [name]: "" },
            };
            if (name === "jobs" && value !== "other") next.jobsOther = "";
            if (name === "moassese" && value !== "other") next.moasseseOther = "";
            return next;
        });
    };

    handleUpdateInfo = (e) => {
        e.preventDefault();
        if (this.state.saving) return;

        this.setState({ generalError: "" });

        const {
            firstName, lastName, phoneNumber, email, codeMelli,
            jobs, jobsOther, moassese, moasseseOther,
        } = this.state;
        const errors = {};

        if (!firstName.trim()) errors.firstName = "نام الزامی است";
        if (!lastName.trim()) errors.lastName = "نام خانوادگی الزامی است";
        if (!phoneNumber.trim()) errors.phoneNumber = "شماره همراه الزامی است";
        else if (!/^09\d{9}$/.test(phoneNumber)) errors.phoneNumber = "شماره همراه معتبر نیست";
        if (!email.trim()) errors.email = "ایمیل الزامی است";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "ایمیل معتبر نیست";
        if (!codeMelli.trim()) errors.codeMelli = "کد ملی الزامی است";
        else if (!/^\d{10}$/.test(codeMelli)) errors.codeMelli = "کد ملی باید ۱۰ رقم باشد";

        if (!jobs) errors.jobs = "شغل الزامی است";
        else if (jobs === "other" && !(jobsOther || "").trim()) errors.jobsOther = "لطفاً شغل خود را وارد کنید";

        if (!moassese) errors.moassese = "محل خدمت الزامی است";
        else if (moassese === "other" && !(moasseseOther || "").trim()) errors.moasseseOther = "لطفاً محل خدمت خود را وارد کنید";

        if (Object.keys(errors).length > 0) {
            this.setState({ errors, generalError: "خطاهای فرم را بررسی کنید" });
            this.scrollToFormTop();
            return;
        }

        this.setState({ saving: true });

        const payload = {
            firstName,
            lastName,
            phoneNumber,
            email,
            codeMelli,
            jobs,
            moassese,
            jobsOther: jobs === "other" ? jobsOther : "",
            moasseseOther: moassese === "other" ? moasseseOther : "",
        };

        axios.patch(
            BASE_URL + "/api/v1/accounts/profile/",
            payload,
            { timeout: TIMEOUT, headers: this.authHeaders() }
        ).then((response) => {
            const data = response.data;
            if (data.code === "success") {
                toastAlerts({ data: { code: "success", message: data.message } });
                if (data.data) {
                    this.setState({
                        jobsOther: data.data.jobsOther || "",
                        moasseseOther: data.data.moasseseOther || "",
                    });
                }
            } else {
                if (data.errors) {
                    const flat = {};
                    Object.keys(data.errors).forEach((key) => {
                        flat[key] = Array.isArray(data.errors[key]) ? data.errors[key][0] : data.errors[key];
                    });
                    this.setState({ errors: flat, generalError: "خطاهای فرم را بررسی کنید" });
                    this.scrollToFormTop();
                }
                toastAlerts(response);
            }
            this.setState({ saving: false });
        }).catch((error) => {
            const errData = error.response?.data;
            if (errData?.errors) {
                const flat = {};
                Object.keys(errData.errors).forEach((key) => {
                    flat[key] = Array.isArray(errData.errors[key]) ? errData.errors[key][0] : errData.errors[key];
                });
                this.setState({ errors: flat, generalError: "خطاهای فرم را بررسی کنید" });
                this.scrollToFormTop();
            }
            toastAlerts(error.response);
            this.setState({ saving: false });
        });
    };

    handleChangePassword = (e) => {
        e.preventDefault();
        if (this.state.changingPassword) return;

        this.setState({ passwordGeneralError: "" });

        const { currentPassword, newPassword, newPassword2 } = this.state;
        const errors = {};

        if (!currentPassword.trim()) errors.currentPassword = "کلمه عبور فعلی الزامی است";
        if (!newPassword.trim()) errors.newPassword = "کلمه عبور جدید الزامی است";
        else if (newPassword.length < 6) errors.newPassword = "کلمه عبور حداقل ۶ کاراکتر باشد";
        if (newPassword !== newPassword2) errors.newPassword2 = "کلمه عبور و تکرار آن یکسان نیستند";

        if (Object.keys(errors).length > 0) {
            this.setState({ passwordErrors: errors, passwordGeneralError: "خطاهای فرم را بررسی کنید" });
            this.scrollToFormTop();
            return;
        }

        this.setState({ changingPassword: true });

        axios.post(
            BASE_URL + "/api/v1/accounts/change-password/",
            { currentPassword, newPassword, newPassword2 },
            { timeout: TIMEOUT, headers: this.authHeaders() }
        ).then((response) => {
            const data = response.data;
            if (data.code === "success") {
                toastAlerts({ data: { code: "success", message: data.message } });
                this.setState({ currentPassword: "", newPassword: "", newPassword2: "", passwordErrors: {}, passwordGeneralError: "" });
            } else {
                if (data.errors) {
                    const flat = {};
                    Object.keys(data.errors).forEach((key) => {
                        flat[key] = Array.isArray(data.errors[key]) ? data.errors[key][0] : data.errors[key];
                    });
                    this.setState({ passwordErrors: flat, passwordGeneralError: "خطاهای فرم را بررسی کنید" });
                    this.scrollToFormTop();
                }
                toastAlerts(response);
            }
            this.setState({ changingPassword: false });
        }).catch((error) => {
            const errData = error.response?.data;
            if (errData?.errors) {
                const flat = {};
                Object.keys(errData.errors).forEach((key) => {
                    flat[key] = Array.isArray(errData.errors[key]) ? errData.errors[key][0] : errData.errors[key];
                });
                this.setState({ passwordErrors: flat, passwordGeneralError: "خطاهای فرم را بررسی کنید" });
                this.scrollToFormTop();
            }
            toastAlerts(error.response);
            this.setState({ changingPassword: false });
        });
    };

    render() {
        const {
            activeTab, loading, saving, changingPassword, checkingAuth,
            firstName, lastName, phoneNumber, email, codeMelli,
            jobs, jobsOther, moassese, moasseseOther,
            errors, generalError,
            currentPassword, newPassword, newPassword2, passwordErrors, passwordGeneralError,
        } = this.state;

        if (checkingAuth || loading) {
            return (
                <HelmetProvider>
                    <Helmet>
                        <title>حساب کاربری | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    </Helmet>
                    {null}
                </HelmetProvider>
            );
        }

        return (
            <HelmetProvider>
                <Helmet>
                    <title>حساب کاربری | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    <link rel="canonical" href="https://nasrme.ac.ir" />
                </Helmet>

                <div className="container-fluid cFlex1 cBg3">
                    {header(this.context)}

                    <div className="cFlex2">
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-12 col-lg-9" id="profile-form-top">

                                    <h1 className="login-title mb-4" style={{ textAlign: "right" }}>حساب کاربری</h1>

                                    <ul className="nav nav-pills mb-4 gap-2">
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                                                onClick={() => this.setState({ activeTab: "info", generalError: "", passwordGeneralError: "" })}
                                            >
                                                اطلاعات کاربری
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === "password" ? "active" : ""}`}
                                                onClick={() => this.setState({ activeTab: "password", generalError: "", passwordGeneralError: "" })}
                                            >
                                                تغییر کلمه عبور
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="login-card" style={{ maxWidth: "100%" }}>

                                        {activeTab === "info" && (
                                            <>
                                                {generalError && (
                                                    <div className="login-general-error">
                                                        {generalError}
                                                    </div>
                                                )}

                                                <form onSubmit={this.handleUpdateInfo} className="login-form profile-form" noValidate>
                                                    <div className="row g-3">
                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>نام</label>
                                                            <input
                                                                name="firstName"
                                                                type="text"
                                                                value={firstName}
                                                                onChange={this.handleChange}
                                                                disabled={saving}
                                                                className={errors.firstName ? "is-invalid" : ""}
                                                            />
                                                            {errors.firstName && <span className="login-field-error">{errors.firstName}</span>}
                                                        </div>

                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>نام خانوادگی</label>
                                                            <input
                                                                name="lastName"
                                                                type="text"
                                                                value={lastName}
                                                                onChange={this.handleChange}
                                                                disabled={saving}
                                                                className={errors.lastName ? "is-invalid" : ""}
                                                            />
                                                            {errors.lastName && <span className="login-field-error">{errors.lastName}</span>}
                                                        </div>

                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>کد ملی</label>
                                                            <input
                                                                name="codeMelli"
                                                                type="text"
                                                                value={codeMelli}
                                                                onChange={this.handleChange}
                                                                disabled={saving}
                                                                className={errors.codeMelli ? "is-invalid" : ""}
                                                            />
                                                            {errors.codeMelli && <span className="login-field-error">{errors.codeMelli}</span>}
                                                        </div>

                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>شماره همراه</label>
                                                            <input
                                                                name="phoneNumber"
                                                                type="text"
                                                                value={phoneNumber}
                                                                onChange={this.handleChange}
                                                                disabled={saving}
                                                                className={errors.phoneNumber ? "is-invalid" : ""}
                                                            />
                                                            {errors.phoneNumber && <span className="login-field-error">{errors.phoneNumber}</span>}
                                                        </div>

                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>ایمیل</label>
                                                            <input
                                                                name="email"
                                                                type="email"
                                                                value={email}
                                                                onChange={this.handleChange}
                                                                disabled={saving}
                                                                className={errors.email ? "is-invalid" : ""}
                                                            />
                                                            {errors.email && <span className="login-field-error">{errors.email}</span>}
                                                        </div>

                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>شغل</label>
                                                            <SearchableSelect
                                                                name="jobs"
                                                                options={JOB_CHOICES}
                                                                value={jobs}
                                                                onChange={this.handleChange}
                                                                placeholder="انتخاب کنید"
                                                                isInvalid={!!errors.jobs}
                                                                isDisabled={saving}
                                                            />
                                                            {errors.jobs && <span className="login-field-error">{errors.jobs}</span>}
                                                        </div>

                                                        {jobs === "other" && (
                                                            <div className="col-12 col-md-6 login-field">
                                                                <label>شغل (سایر)</label>
                                                                <input
                                                                    name="jobsOther"
                                                                    type="text"
                                                                    value={jobsOther}
                                                                    onChange={this.handleChange}
                                                                    disabled={saving}
                                                                    className={errors.jobsOther ? "is-invalid" : ""}
                                                                />
                                                                {errors.jobsOther && <span className="login-field-error">{errors.jobsOther}</span>}
                                                            </div>
                                                        )}

                                                        <div className="col-12 col-md-6 login-field">
                                                            <label>محل خدمت</label>
                                                            <SearchableSelect
                                                                name="moassese"
                                                                options={MOASSESE_CHOICES}
                                                                value={moassese}
                                                                onChange={this.handleChange}
                                                                placeholder="انتخاب کنید"
                                                                isInvalid={!!errors.moassese}
                                                                isDisabled={saving}
                                                            />
                                                            {errors.moassese && <span className="login-field-error">{errors.moassese}</span>}
                                                        </div>

                                                        {moassese === "other" && (
                                                            <div className="col-12 col-md-6 login-field">
                                                                <label>محل خدمت (سایر)</label>
                                                                <input
                                                                    name="moasseseOther"
                                                                    type="text"
                                                                    value={moasseseOther}
                                                                    onChange={this.handleChange}
                                                                    disabled={saving}
                                                                    className={errors.moasseseOther ? "is-invalid" : ""}
                                                                />
                                                                {errors.moasseseOther && <span className="login-field-error">{errors.moasseseOther}</span>}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="login-actions mt-3">
                                                        <button type="submit" className="login-btn" disabled={saving}>
                                                            ذخیره تغییرات
                                                        </button>
                                                    </div>
                                                </form>
                                            </>
                                        )}

                                        {activeTab === "password" && (
                                            <>
                                                {passwordGeneralError && (
                                                    <div className="login-general-error">
                                                        {passwordGeneralError}
                                                    </div>
                                                )}

                                                <form onSubmit={this.handleChangePassword} className="login-form profile-form" noValidate>
                                                    <div className="login-field">
                                                        <label>کلمه عبور فعلی</label>
                                                        <input
                                                            name="currentPassword"
                                                            type="password"
                                                            value={currentPassword}
                                                            onChange={this.handleChange}
                                                            disabled={changingPassword}
                                                            autoComplete="current-password"
                                                            className={passwordErrors.currentPassword ? "is-invalid" : ""}
                                                        />
                                                        {passwordErrors.currentPassword && <span className="login-field-error">{passwordErrors.currentPassword}</span>}
                                                    </div>

                                                    <div className="login-field">
                                                        <label>کلمه عبور جدید</label>
                                                        <input
                                                            name="newPassword"
                                                            type="password"
                                                            value={newPassword}
                                                            onChange={this.handleChange}
                                                            disabled={changingPassword}
                                                            autoComplete="new-password"
                                                            className={passwordErrors.newPassword ? "is-invalid" : ""}
                                                        />
                                                        {passwordErrors.newPassword && <span className="login-field-error">{passwordErrors.newPassword}</span>}
                                                    </div>

                                                    <div className="login-field">
                                                        <label>تکرار کلمه عبور جدید</label>
                                                        <input
                                                            name="newPassword2"
                                                            type="password"
                                                            value={newPassword2}
                                                            onChange={this.handleChange}
                                                            disabled={changingPassword}
                                                            autoComplete="new-password"
                                                            className={passwordErrors.newPassword2 ? "is-invalid" : ""}
                                                        />
                                                        {passwordErrors.newPassword2 && <span className="login-field-error">{passwordErrors.newPassword2}</span>}
                                                    </div>

                                                    <div className="login-actions mt-3">
                                                        <button type="submit" className="login-btn" disabled={changingPassword}>
                                                            تغییر کلمه عبور
                                                        </button>
                                                    </div>
                                                </form>
                                            </>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {footer(true)}
                </div>
            </HelmetProvider>
        );
    }
}

export default withRouter(Profile);